import { render, staticRenderFns } from "./PayMain.vue?vue&type=template&id=6198999c&scoped=true&"
import script from "./PayMain.vue?vue&type=script&lang=js&"
export * from "./PayMain.vue?vue&type=script&lang=js&"
import style0 from "./PayMain.vue?vue&type=style&index=0&id=6198999c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6198999c",
  null
  
)

export default component.exports